export const FAX_NUMBER_FORMATTED_REGEXP = /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/;
